const takeNumber = (values: any[]) => {
  const numbers = [];
  for (const value of values) {
    const num = Number(value);
    if (!Number.isNaN(num)) {
      numbers.push(num);
    }
  }
  return numbers;
};

export default takeNumber;
